module.exports = __webpack_public_path__ + "static/kw51_img_2-f188f33b566f1b090d032227d418440b.png";